
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { IconName } from "@/lib/icons/icons";
import RawIcon from "@/components/UI/RawIcon.vue";
import Icon from "@/components/UI/Icon.vue";
import { IconRotation } from "@/types/icons";

@Component({
  components: { Icon, RawIcon }
})
export default class IconButton extends Vue {
  @Prop()
  icon!: IconName;

  @Prop({
    default: false
  })
  active!: boolean;

  @Prop({
    default: false
  })
  disabled!: boolean;

  @Prop()
  testId!: string;

  @Prop()
  size?: string;

  @Prop()
  rotate?: IconRotation;

  @Prop({ default: false })
  xSmall!: boolean;

  @Prop({ default: false })
  small!: boolean;

  get classList() {
    return {
      "breakdance-toolbar-icon-button": true,
      "breakdance-toolbar-icon-button-active": this.active,
      "breakdance-toolbar-icon-button-small-button": this.small,
      "breakdance-toolbar-icon-button-xs-button": this.xSmall,
      "breakdance-toolbar-icon-button-disabled": this.disabled
    };
  }

  get iconColor() {
    return this.active ? "brand_primary" : "gray1000";
  }

  get listeners() {
    if (!this.disabled) {
      return this.$listeners;
    }
    return false;
  }
}
